import React from 'react';
import { useI18n } from 'next-localization';

import Section from '../section';

type Props = {
  fields: {
    patientInformation: {
      patientName: string;
      birthDate: string;
      gender: string;
      address: string;
      address2?: string;
      city: string;
      state: string;
      zip: string;
      phone: string;
      email: string;
    };
  };
};

const PatientInformationSection = ({ fields }: Props): JSX.Element => {
  const { t } = useI18n();

  return (
    <Section>
      <div className="row">
        <div className="col-12 mb-2">
          <h2 className="neu-display-4 pb-2 neu-text-gray-70">
            {t('OAS.Booking.Confirmation.PatientInformation')}
          </h2>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <div className="row mb-2">
            <div className="col-12 mb-1">
              <p className="neu-display-6 neu-text-gray-70">
                {t('OAS.Booking.Appointment.PatientInformation')}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.patientInformation.patientName}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.patientInformation.birthDate}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">{fields.patientInformation.gender}</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <div className="row">
            <div className="col-12 mb-1">
              <p className="neu-display-6 neu-text-gray-70">
                {t('OAS.Booking.Appointment.PatientAddress')}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">{fields.patientInformation.address}</p>
              {fields.patientInformation.address2 && (
                <p className="neu-display-6 neu-text-gray-70">
                  {fields.patientInformation.address2}
                </p>
              )}
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.patientInformation.city}, {fields.patientInformation.state}{' '}
                {fields.patientInformation.zip}
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <div className="row">
            <div className="col-12 mb-2">
              <div className="row">
                <div className="col-12 mb-1">
                  <p className="neu-display-6 neu-text-gray-70">
                    {t('OAS.Booking.Appointment.PatientContact')}
                  </p>
                </div>
                <div className="col-12">
                  <p className="neu-display-6 neu-text-gray-70">
                    {fields.patientInformation.phone}
                  </p>
                </div>
                <div className="col-12">
                  <p className="neu-display-6 neu-text-gray-70">
                    {fields.patientInformation.email}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default PatientInformationSection;
